import { FontIcon, registerIcons } from "@fluentui/react";
import React from "react";

interface Props {
  title?: string;
  className?: string;
}

registerIcons({
  icons: {
    "github-svg": (
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 130 130"
        enable-background="new 0 0 130 130"
      >
        <g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            fill="#191717"
            d="M65.6,6.4c-33.3,0-60.4,27-60.4,60.4c0,26.7,17.3,49.3,41.3,57.3
           c3,0.6,4.1-1.3,4.1-2.9c0-1.4-0.1-6.2-0.1-11.2c-16.8,3.7-20.3-7.1-20.3-7.1c-2.7-7-6.7-8.8-6.7-8.8c-5.5-3.7,0.4-3.7,0.4-3.7
           c6.1,0.4,9.3,6.2,9.3,6.2c5.4,9.2,14.1,6.6,17.6,5c0.5-3.9,2.1-6.6,3.8-8.1C41.2,92,27.1,86.8,27.1,63.7c0-6.6,2.4-12,6.2-16.2
           c-0.6-1.5-2.7-7.7,0.6-16c0,0,5.1-1.6,16.6,6.2c4.8-1.3,10-2,15.1-2c5.1,0,10.3,0.7,15.1,2c11.5-7.8,16.6-6.2,16.6-6.2
           c3.3,8.3,1.2,14.5,0.6,16c3.9,4.2,6.2,9.6,6.2,16.2c0,23.2-14.1,28.3-27.6,29.8c2.2,1.9,4.1,5.5,4.1,11.2c0,8.1-0.1,14.6-0.1,16.6
           c0,1.6,1.1,3.5,4.1,2.9c24-8,41.3-30.6,41.3-57.3C126,33.5,99,6.4,65.6,6.4z"
          />
          <path
            fill="#191717"
            d="M28.1,93.1c-0.1,0.3-0.6,0.4-1,0.2c-0.4-0.2-0.7-0.6-0.5-0.9c0.1-0.3,0.6-0.4,1-0.2
           C28,92.4,28.2,92.8,28.1,93.1L28.1,93.1z M27.3,92.6"
          />
          <path
            fill="#191717"
            d="M30.5,95.9c-0.3,0.3-0.9,0.1-1.2-0.3c-0.4-0.4-0.5-1-0.2-1.3c0.3-0.3,0.8-0.1,1.2,0.3
           C30.8,95,30.8,95.6,30.5,95.9L30.5,95.9z M30,95.2"
          />
          <path
            fill="#191717"
            d="M32.9,99.3c-0.4,0.3-1,0-1.3-0.5c-0.4-0.5-0.4-1.2,0-1.4c0.4-0.3,1,0,1.3,0.5
           C33.3,98.4,33.3,99.1,32.9,99.3L32.9,99.3z M32.9,99.3"
          />
          <path
            fill="#191717"
            d="M36.2,102.7c-0.3,0.4-1,0.3-1.6-0.2c-0.5-0.5-0.7-1.2-0.3-1.5c0.3-0.4,1-0.3,1.6,0.2
           C36.4,101.6,36.5,102.3,36.2,102.7L36.2,102.7z M36.2,102.7"
          />
          <path
            fill="#191717"
            d="M40.7,104.7c-0.1,0.5-0.8,0.7-1.5,0.5c-0.7-0.2-1.1-0.8-1-1.2c0.1-0.5,0.8-0.7,1.5-0.5
           C40.4,103.6,40.8,104.2,40.7,104.7L40.7,104.7z M40.7,104.7"
          />
          <path
            fill="#191717"
            d="M45.6,105c0,0.5-0.6,0.9-1.3,0.9c-0.7,0-1.3-0.4-1.3-0.9c0-0.5,0.6-0.9,1.3-0.9
           C45,104.1,45.6,104.5,45.6,105L45.6,105z M45.6,105"
          />
          <path
            fill="#191717"
            d="M50.2,104.2c0.1,0.5-0.4,1-1.1,1.1c-0.7,0.1-1.3-0.2-1.4-0.7c-0.1-0.5,0.4-1,1.1-1.1
           C49.5,103.4,50.1,103.7,50.2,104.2L50.2,104.2z M50.2,104.2"
          />
        </g>
      </svg>
    ),
  },
});

const GitHubLogo = (props: Props) => {
  return (
    <span>
      <FontIcon iconName="github-svg" title={props.title || ""} className={props.className || ""} />
    </span>
  );
};

export default GitHubLogo;
